import React from 'react'
import Image from '../../../images/sellerpolicies/8.png'

const Intellectual_property = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>INTELLECTUAL PROPERTY</h2>
            <p>The Seller ensures that the product is imported, manufactured, production, sale, distribution, and use of the Products do not infringe directly or indirectly any Intellectual Property. The Seller ensures that featuring of the Products on the Platform does not, directly or indirectly, infringe any Intellectual Property.</p>
            <p>The Seller ensures to KAAY that it is not aware of any claims made by any third party with regards to any alleged or actual patent, copyright, trade secret, trademark, trade name, or other intellectual property right infringement or another claim, demand or action resulting from the manufacture, sale, distribution or use of the Products.</p>
        </div>
      </div>
    </div>
  )
}

export default Intellectual_property
